// export const domain = "http://127.0.0.1:8000/api";

// export const domain = "http://oscctestapi.kisra.co.th/api";

export const domain = "https://osccapi.kisrasprint.com/api";
